import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../../models/api-response.model';
import { IncentiveDetails } from '../../../../models/incentive-details.model';
import { PartnerModel } from '../../../../models/partner.model';
import { CommonService } from '../../../common/common.service';
import { SettingsService } from '../../../common/settings.service';
import { CommonSharedModule } from '../../../common/shared.module';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';

@Component({
  selector: 'app-partner-details',
  templateUrl: './partner-details.component.html',
  styleUrls: ['./partner-details.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class PartnerDetailsComponent implements OnInit {
  @Input() incentiveDetails!: IncentiveDetails;
  @Output() refreshPartnerInput = new EventEmitter<void>();
  formPartner!: FormGroup;
  isReadonlypart = true;
  partbtnNav = false;
  addPartner!: PartnerModel;
  uname!: string;
  apires!: ApiResponse;
  partnermsgs!: any[];
  incentiveId!: number;

  constructor(
    private formBuilder: FormBuilder,
    private osmEdit: OsmosisEditService,
    private settingsServices: SettingsService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.formPartner = this.formBuilder.group({
      mPNID: [''],
      pmomPNID: [''],
      partnerName: [''],
      pmopartnerName: [''],
      partnerInputRequestorContact: [''],
      partnerInputRequestorEmail: [''],
      partnerType: [''],
      countryName: [''],
      customerLocation: [''],
      InternalRefPartnerName: [''],
      partnerOneID: [''],
      partnerLocation: [''],
      partnerEarnedLocation: [''],
      partnerAreaLocationA14: [''],
      additionalContactEmails: ['']
    });
    this.setPartnerDetails();
  }

  setPartnerDetails() {
    this.formPartner.patchValue({
      mPNID: this.incentiveDetails.partnerInputMPNID,
      partnerName: this.incentiveDetails.partnerInputPartnerName,
      partnerInputRequestorContact:
        this.incentiveDetails.partnerInputRequestorContact,
      partnerInputRequestorEmail:
        this.incentiveDetails.partnerInputRequestorEmail,
      countryName: this.incentiveDetails.countryName,
      InternalRefPartnerName: this.incentiveDetails.partnerName,
      partnerOneID: this.incentiveDetails.partnerOneID,
      partnerLocation: this.incentiveDetails.partnerLocation,
      partnerEarnedLocation: this.incentiveDetails.partnerEarnedLocation,
      partnerAreaLocationA14: this.incentiveDetails.partnerAreaLocationA14,
      additionalContactEmails: this.incentiveDetails.additionalContactEmails,
      pmomPNID: this.incentiveDetails.pmoConfirmedPartnerMPNID,
      pmopartnerName: this.incentiveDetails.pmoConfirmedPartnerName
    });
    this.formPartner.controls['partnerType'].setValue({
      partnerTypeId: this.incentiveDetails.partnerTypeId,
      partnerType: this.incentiveDetails.partnerTypeIdName
    });
    this.incentiveId = this.incentiveDetails.requestDetailId || -1;
  }

  editPartnerDetails() {
    this.isReadonlypart = false;
    this.partbtnNav = true;
    this.partnermsgs = [];
  }

  editPartnerDetailsCancel() {
    this.isReadonlypart = true;
    this.partbtnNav = false;
    this.partnermsgs = [];
    this.setPartnerDetails();
  }

  get release(): string {
    return environment.isProdEnvironment ? 'Prod' : 'Dev';
  }

  onSubmitPartner() {
    this.uname = this.settingsServices.AliasName || '';
    this.addPartner = {
      requestDetailId: this.incentiveDetails.requestDetailId,
      partnerInputMpnid: this.formPartner.controls['mPNID'].value,
      pmoconfirmedPartnerMpnid: this.formPartner.controls['pmomPNID'].value,
      partnerInputPartnerName: this.formPartner.controls['partnerName'].value,
      pmoconfirmedPartnerName:
        this.formPartner.controls['pmopartnerName'].value,
      partnerInputRequestorContact:
        this.formPartner.controls['partnerInputRequestorContact'].value,
      partnerInputRequestorEmail:
        this.formPartner.controls['partnerInputRequestorEmail'].value,
      partnerTypeId:
        this.formPartner.controls['partnerType'].value.partnerTypeId,
      partnerTypeIdName:
        this.formPartner.controls['partnerType'].value.partnerType,
      partnerName: this.formPartner.controls['InternalRefPartnerName'].value,
      partnerOneId: this.formPartner.controls['partnerOneID'].value,
      partnerLocation: this.formPartner.controls['partnerLocation'].value,
      partnerEarnedLocation:
        this.formPartner.controls['partnerEarnedLocation'].value,
      partnerAreaLocationA14:
        this.formPartner.controls['partnerAreaLocationA14'].value,
      additionalContactEmails:
        this.formPartner.controls['additionalContactEmails'].value,
      lastUserAlias: this.uname
    };

    this.osmEdit.addCsiPartner(this.addPartner).subscribe(
      messageResponse => {
        this.apires = messageResponse;
        if (this.apires.success === true) {
          this.refreshPartnerInput.emit();
          this.partnermsgs = [];
          this.partnermsgs.push({
            severity: 'success',
            detail: 'Records Saved Successfully.'
          });
          this.isReadonlypart = true;
          this.partbtnNav = false;
        }
        if (this.apires.success === false) {
          this.partnermsgs = [];
          this.partnermsgs.push({
            severity: 'error',
            detail: this.apires.errorMessages
              ? this.apires.errorMessages[0]
              : 'Unknown error'
          });
        }
      },
      error => {
        this.partnermsgs = [];
        let errors: string[] = [];
        if (error.status === 400) {
          errors = this.commonService.getBadRequestErrors(error);
          for (const msg of errors) {
            this.partnermsgs.push({ severity: 'warn', detail: msg });
          }
        } else {
          this.partnermsgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured while Adding Partner Details'
          });
        }
      }
    );
  }
}
